module.exports = __webpack_public_path__ + "static/img/wap.f8a86b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cn/国际高中/wap.svg
// module id = yC5l
// module chunks = 16